module.exports = __webpack_public_path__ + "img/1.8ca31758.png";